module.exports = __webpack_public_path__ + "img/icon-fluids.bd3669eb.svg";